import { BaseService } from "./baseService";
import { ChannelAttributes } from "./types";

export class ChannelService extends BaseService {

  /**
   * Fetch channel by event key
   */
  static async getChannelByEventKey(eventKey: string): Promise<ChannelAttributes[]> {
    try {
      const response = await this.get(`/channels/${eventKey}`);
      return await this.handleResponse<ChannelAttributes[]>(response);
    } catch (error) {
      console.error(`Error fetching channel for event ${eventKey}:`, error);
      throw error;
    }
  }
}